import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";
import { motion } from "framer-motion";
import { useTheme } from "@/b2b/context/ThemeContext";
import { headingVariants } from "@/lib/data";
import Header from "@/b2b/components/Header";
import Select from "@/components/common/Input/Select";
import TextField from "@/components/common/Input/TextField";
import { fetchData, updateFunctionB2B } from "@/lib/helper";
import { set } from "date-fns";
import { ClipLoader } from "react-spinners";
import PrimaryButton from "../components/PrimaryButton";
import DynamicInputForm from "@/b2b/components/DynamicInputForm.jsx";
import { trackConsent } from "@/lib/apis";
import { Pointer } from "lucide-react";

const maintenanceConfig = [
  {
    type: "checkbox",
    label:
      "I have understood why this is necessary and how it works and agree to the maintenance cover.",
    name: "acceptedMaintenance",
    required: true,
  },
];

const MaintenanceScreen = ({ theme }) => {
  const navigate = useNavigate();
  // const [disableNextBtn, setDisableNextBtn] = useState(true);
  const { userIdentifier } = useParams();
  const [journey, setJourney] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("user_identifier");
  const partner = localStorage.getItem("partnerIdentifier");
  const [formData, setFormData] = useState({});
  const [error, setError] = useState();

  const maintenanceNotes = [
    `It covers any damages or dues reported by our partner ${theme.name} after your stay.`,
    `After your lease ends (${journey?.maintenanceTenure} months), the amount will be auto-debited via NACH.`,
    `If all’s good, you’ll get the full ₹${journey.maintenanceAmount} back.`,
  ];

  const handleNext = async () => {
    if (loading) return;
    setLoading(true);
    setError(null);
    try {
      // check formData
      console.log(formData?.acceptedMaintenance?.target?.checked, "formData");
      if (!formData?.acceptedMaintenance?.target?.checked) {
        setError("Please check the box to continue.");
        return;
      }

      const platform =
        navigator?.userAgentData?.platform ||
        navigator.platform ||
        localStorage.getItem("UTM_SOURCE");

      await trackConsent(
        "checkbox",
        "maintenance-cover",
        journey?.maintenanceAmount?.toString(),
        platform,
        maintenanceConfig?.[0]?.label,
      );
 
      navigate(`/b/${token}`);
    } catch (error) {
      console.error(error);
      setError(error?.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const loadData = async () => {
    try {
      const { journey } = await fetchData("journey/full");
      setJourney(journey);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();
  }, [token]);

  // KOTS has no maintenance cover — if a KOTS user ever lands here (back button
  // or stale URL), skip the screen and continue the journey instead of showing it.
  useEffect(() => {
    if (partner === "kots") {
      navigate(`/b/${token}?step=onboarding&partner=${partner}`, {
        replace: true,
      });
    }
  }, [partner, token]);

  if (partner === "kots") return null;

  return (
    <Div100vh
      className={`flex flex-col justify-between p-8 gap-6 ${theme?.backgroundColor} ${theme?.text}`}
    >
      <div className="space-y-6">
        <Header heading="Maintenance Cover" subheading="How it works?" />
        <div className={`${theme?.subHeadingColor} text-wrap`}>
          A refundable deposit of{" "}
          <span className={`text-lg ${theme?.subHeadingColor}`}>
            ₹<span className="font-mono">{journey?.maintenanceAmount}</span>
          </span>{" "}
          will be paid on your behalf to {theme.name}.
        </div>
        <div className="space-y-4">
          {maintenanceNotes?.map((note) => {
            return (
              <div
                className={`flex gap-2 rounded-lg border shadow-lg text-sm p-4 ${theme?.textColor}`}
              >
                <div>
                  <Pointer className="size-4 rotate-90" />{" "}
                </div>
                <div className={`${theme?.textColor} text-wrap`}>{note}</div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="space-y-3">
        <DynamicInputForm
          formConfig={maintenanceConfig}
          formData={formData}
          setFormData={setFormData}
          setError={setError}
        />
        {error && (
          <div className="w-full p-2 px-4 bg-red-400/10 text-red-400 rounded-lg mt-4">
            {error}
          </div>
        )}
        <PrimaryButton
          text={"Continue"}
          loading={loading}
          handleClick={() => handleNext()}
          disabled={loading}
          // className={theme.primary}
        />
      </div>
    </Div100vh>
  );
};

export default MaintenanceScreen;
